// removed by extract-text-webpack-plugin
module.exports = {"drawer-container":"drawer__drawer-container___3oJL4","drawer":"drawer__drawer___2-8Ew","slide":"drawer__slide___1X0xH","close-drawer":"drawer__close-drawer___2ZnXC","close":"drawer__close___1EUSp"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/drawer.scss
// module id = 1304
// module chunks = 0